export default {
  POPUP: 'NotificationType.POPUP',
  ALERT: 'NotificationType.ALERT'
}
